import React, { useRef, useState, useEffect } from "react";

const SliderLabel = ({value}) => {
  return (
    <span className="text-[10px] w-5 h-5 font-medium bg-tertiary/50 text-center text-secondary color-[#CFCFCF] flex items-center justify-center rounded-[4px] overflow-hidden">
      {value}
    </span>
  );
};

const CustomSliderDual = ({
  label,
  min = 0,
  max = 100,
  value = [min, max],
  onChange,
}) => {
  const trackRef = useRef(null);
  const [draggingThumb, setDraggingThumb] = useState(null);

  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const getPercent = (val) => ((val - min) / (max - min)) * 100;

  const handleMouseDown = (thumb) => (e) => {
    e.preventDefault();
    setDraggingThumb(thumb);
  };

  const handleMouseMove = (e) => {
    if (!draggingThumb) return;

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const rect = trackRef.current.getBoundingClientRect();
    let newPercent = ((clientX - rect.left) / rect.width) * 100;
    newPercent = Math.min(100, Math.max(0, newPercent));
    const newValue = Math.round(min + ((max - min) * newPercent) / 100);

    const updated = [...localValue];
    if (draggingThumb === "min") {
      updated[0] = Math.min(newValue, localValue[1] - 1);
    } else {
      updated[1] = Math.max(newValue, localValue[0] + 1);
    }

    setLocalValue(updated);
    onChange(updated);
  };

  const handleMouseUp = () => {
    setDraggingThumb(null);
  };

  useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    window.addEventListener("touchmove", handleMouseMove);
    window.addEventListener("touchend", handleMouseUp);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("touchmove", handleMouseMove);
      window.removeEventListener("touchend", handleMouseUp);
    };
  });

  const minPercent = getPercent(localValue[0]);
  const maxPercent = getPercent(localValue[1]);

  return (
    <div className="w-full select-none">
      <label className={`text-[16px] text-[#8D8D8D] mb-[6px] lg:mb-[13px] -ml-2 block ${(label === 'bpm') && 'uppercase'} font-semibold font-public-sans leading-[100%]`}>
        {label}
      </label>
      <div className="relative w-full flex flex-row justify-between items-center gap-3">
        <SliderLabel value={localValue[0]} />
        <div
          ref={trackRef}
          className="relative flex-1 h-[14px] bg-[#444] rounded-full"
        >
          {/* Gradient Track */}
          <div
            className="absolute h-[14px] rounded-full bg-gradient-to-r from-cyan-400 to-blue-500"
            style={{
              left: `${minPercent}%`,
              width: `${maxPercent - minPercent}%`,
            }}
          />

          {/* Left Thumb */}
          <div
            className="absolute top-1/2 -translate-y-1/2 w-[17px] h-[17px] bg-[#197AD0] border-[3px] border-white rounded-full cursor-pointer"
            style={{ left: `calc(${minPercent}% - 10px)` }}
            onMouseDown={handleMouseDown("min")}
            onTouchStart={handleMouseDown("min")}
          />

          {/* Right Thumb */}
          <div
            className="absolute top-1/2 -translate-y-1/2 w-[17px] h-[17px] bg-[#197AD0] border-[3px] border-white rounded-full cursor-pointer"
            style={{ left: `calc(${maxPercent}% - 10px)` }}
            onMouseDown={handleMouseDown("max")}
            onTouchStart={handleMouseDown("max")}
          />
        </div>
        <SliderLabel value={localValue[1]} />
      </div>
    </div>
  );
};

export default CustomSliderDual;
